import SPAConfig, { SPAConfigValue } from "./baseComponents/SPAConfig";

declare const ENV_TYPE: string;
declare const ENV_SUBLEDGER_API: string;
interface IBaseConfiguration {
  [key: string]: SPAConfigValue;
}
interface IConfiguration extends IBaseConfiguration {
  type: string;
  clientId: string;
  directoryId: string;
  subledgerUrl: string;
  datamallUrl: string;
  attachmentUrl: string;
  instrumentationKey: string;
  fdaBotURL: string;
  hostappid: string;
}

function GetDefaultConfiguration(): IConfiguration {
  let cfg = {
    type: ENV_TYPE,
    clientId: "44793125-45fa-4db6-bec0-feeacd25a65f",
    directoryId: "72f988bf-86f1-41af-91ab-2d7cd011db47",
    // don't ever use these unless you are testing something directly with the API
    // if APIM is not working it is a big problem
    // subledgerUrl: "https://slentriesapi-dev.azurewebsites.net/api/v1.0.0/sl",
    // datamallUrl: "https://strmasterdata-dev.azurewebsites.net/api/Datamall",
    // attachmentUrl: "https://strdocumentapi-dev.azurewebsites.net/api/v1.0.0",
    subledgerUrl: "https://localhost:5003/api/v1.0.0/sl",
    datamallUrl: "https://localhost:5001/api/Datamall",
    attachmentUrl: "https://localhost:5005/api/v1.0.0",
    instrumentationKey: "902a2369-e627-4ff6-8065-ed32c1a5c444",
    fdaBotURL: "https://onefinancecdn.azureedge.net/onefinancestore/onefinancebot-staging.js",
    hostappid: "https://aka.ms/fafinsup"
  };

  if (cfg.type.indexOf("accessibility") !== -1) {
    const subledgerApi = ENV_SUBLEDGER_API;
    cfg = Object.assign(cfg, {
      subledgerUrl: `${subledgerApi}/api/v1.0.0/sl`,
      datamallUrl: `${subledgerApi}/api/Datamall`,
      attachmentUrl: `${subledgerApi}/api/v1.0.0`
    });
  }

  return cfg;
}

const environconfigs = {
  dev: {
    type: ENV_TYPE,
    clientId: "44793125-45fa-4db6-bec0-feeacd25a65f",
    directoryId: "72f988bf-86f1-41af-91ab-2d7cd011db47",
    subledgerUrl: "https://fde-SLEntriesApidev-f3efgha6c8c2hshc.z01.azurefd.net/api/v1.0.0/sl",
    datamallUrl: "https://fde-strmasterdatadev-b9brg8ajb8heddf4.z01.azurefd.net/api/Datamall",
    attachmentUrl: "https://fde-strDocumentApidev-gbcsenctb0btfgf4.z01.azurefd.net/api/v1.0.0",
    instrumentationKey: "902a2369-e627-4ff6-8065-ed32c1a5c444",
    fdaBotURL: "https://onefinancecdn.azureedge.net/onefinancestore/onefinancebot-staging.js",
    hostappid: "https://aka.ms/fafinsup"
  },
  uat: {
    type: ENV_TYPE,
    clientId: "44793125-45fa-4db6-bec0-feeacd25a65f",
    directoryId: "72f988bf-86f1-41af-91ab-2d7cd011db47",
    subledgerUrl: "https://fde-slentriesapiuat-a6dabhbpgydzc0a4.z01.azurefd.net/api/v1.0.0/sl",
    datamallUrl: "https://fde-strmasterdatauat-hjetagfefseyb3bd.z01.azurefd.net/api/Datamall",
    attachmentUrl: "https://fde-strdocumentapiuat-exefbeh7dhdfckg0.z01.azurefd.net/api/v1.0.0",
    instrumentationKey: "8b431ba5-8ad5-4dfb-b603-3c4c720ad24e",
    fdaBotURL: "https://onefinancecdn.azureedge.net/onefinancestore/onefinancebot-staging.js",
    hostappid: "https://aka.ms/fafinsup"
  },
  prod: {
    type: ENV_TYPE,
    clientId: "d878a94a-f54d-4f57-b5fb-fd0c87bc380c",
    directoryId: "72f988bf-86f1-41af-91ab-2d7cd011db47",
    subledgerUrl: "https://fde-slentriesapiprod-epaddse3cpayfpgt.z01.azurefd.net/api/v1.0.0/sl",
    datamallUrl: "https://fde-strmasterdataprod-eacbg2dsafddffdb.z01.azurefd.net/api/Datamall",
    attachmentUrl: "https://fde-strdocumentsapiprod-g5e0cta7cef0fsc0.z01.azurefd.net/api/v1.0.0",
    instrumentationKey: "a909018e-fe4d-49ce-a75a-795055d992d5",
    fdaBotURL: "https://onefinancecdn.azureedge.net/onefinancestore/onefinancebot.js",
    hostappid: "https://aka.ms/fafinsup"
  },
  localhost: {
    type: ENV_TYPE,
    clientId: "44793125-45fa-4db6-bec0-feeacd25a65f",
    directoryId: "72f988bf-86f1-41af-91ab-2d7cd011db47",
    // Using dev Front Door endpoints for localhost configuration
    subledgerUrl: "https://fde-SLEntriesApidev-f3efgha6c8c2hshc.z01.azurefd.net/api/v1.0.0/sl",
    datamallUrl: "https://fde-strmasterdatadev-b9brg8ajb8heddf4.z01.azurefd.net/api/Datamall",
    attachmentUrl: "https://fde-strDocumentApidev-gbcsenctb0btfgf4.z01.azurefd.net/api/v1.0.0",
    instrumentationKey: "902a2369-e627-4ff6-8065-ed32c1a5c444",
    fdaBotURL: "https://onefinancecdn.azureedge.net/onefinancestore/onefinancebot-staging.js",
    hostappid: "https://aka.ms/fafinsup"
  }
};

const defaultConfiguration = GetDefaultConfiguration();

export const config = new SPAConfig(defaultConfiguration, {
  "fde-stsubledgerclientdev-bweydzd6fag7hxgm.z01.azurefd.net": environconfigs.dev,
  "dev.subledger.microsoft.com": environconfigs.dev,
  "fde-stsubledgerclientuat-arcuebggavf5gmfx.z01.azurefd.net": environconfigs.uat,
  "uat.subledger.microsoft.com": environconfigs.uat,
  "subledger.microsoft.com": environconfigs.prod,
  localhostDev: environconfigs.localhost
});
